import { render, staticRenderFns } from "./QuickSetting.vue?vue&type=template&id=0550b132"
import script from "./QuickSetting.vue?vue&type=script&lang=js"
export * from "./QuickSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports